import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-filter",
  "use": "icon-filter-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol viewBox=\"0 0 18 18\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-filter\">\n<path d=\"M0.75 0V1.75781L0.914062 1.96875L6.75 9.25781V18L7.94531 17.1094L10.9453 14.8594L11.25 14.625V9.25781L17.0859 1.96875L17.25 1.75781V0H0.75ZM2.46094 1.5H15.5391L10.1484 8.25H7.85156L2.46094 1.5ZM8.25 9.75H9.75V13.875L8.25 15V9.75Z\" fill=\"#0284C7\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol